import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@mui/styles";
import { Typography, TextField, Button } from "@mui/material";
import { withFormik, Form } from "formik";
import Yup from "yup";
import Page from "common/components/Page";
import { login } from "common/auth/actions";

import Logo from "../../images/hilo-admin-dark.png";

const Login = ({
  classes,
  values,
  handleChange,
  errors,
  touched,
  isSubmitting,
  httpError,
  loginFailed,
  handleBlur,
}) => (
  <Page style={{ backgroundColor: "#000" }}>
    <Typography
      variant="h5"
      component="h2"
      color="primary"
      classes={{ root: classes.root }}
    >
      <img src={Logo} height="auto" alt="Hilo" className={classes.headingImg} />
    </Typography>
    <Form className={classes.container}>
      <TextField
        error={touched.email && !!errors.email}
        className={classes.textField}
        id="email"
        type="email"
        label="Enter your email"
        margin="normal"
        value={values.email}
        onChange={handleChange}
        onBlur={handleBlur}
        helperText={touched.email && errors.email}
      />
      <TextField
        error={touched.password && !!errors.password}
        className={classes.textField}
        id="password"
        label="Enter your password"
        margin="normal"
        type="password"
        value={values.password}
        onChange={handleChange}
        onBlur={handleBlur}
        helperText={touched.password && errors.password}
      />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        className={classes.button}
        disabled={isSubmitting}
      >
        Login
      </Button>
      {loginFailed && (
        <div className={classes.errorContainer} style={{ textAlign: "center" }}>
          {Object.keys(httpError).map((k, index) => {
            return (
              <Typography
                variant="caption"
                className={classes.httpError}
                key={index}
              >
                {`Error: ${httpError[k]}`}
              </Typography>
            );
          })}
        </div>
      )}
    </Form>
  </Page>
);

Login.propTypes = {
  values: PropTypes.shape({
    email: PropTypes.string.isRequired,
  }),
  handleChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  touched: PropTypes.object,
  isSubmitting: PropTypes.bool,
  login: PropTypes.func.isRequired,
  loginFailed: PropTypes.bool,
  httpError: PropTypes.shape({
    statusText: PropTypes.string,
  }),
  classes: PropTypes.object,
};

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  root: {
    textAlign: "center",
    textTransform: "uppercase",
  },
  headingImg: {
    height: "1em",
  },
  headingText: {
    verticalAlign: "text-top",
    lineHeight: 1.1,
  },
  textField: {
    width: "100%",
  },
  button: {
    marginTop: theme.spacing(2),
  },
  errorContainer: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  httpError: {
    color: theme.palette.error.main,
  },
});

const formikOptions = {
  mapPropsToValues({ email, password }) {
    return {
      email: email || "",
      password: password || "",
    };
  },
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email("Email is not valid")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
  }),
  handleSubmit(values, { props, setSubmitting, setErrors }) {
    const { login } = props;
    login(values).then((payload) => {
      payload && payload.error && setSubmitting(false) && setErrors();
    });
  },
};

const mapStateToProps = (state) => ({
  loginFailed: state.auth.loginFailed,
  httpError: state.auth.error,
});

const enhanced = compose(
  connect(mapStateToProps, { login }),
  withStyles(styles),
  withFormik(formikOptions),
);

export default enhanced(Login);
